// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-2xBxX";
var _3 = "totalRefund-2Sqqo";
var _4 = "priceHeadTitle-2DTa2";
var _5 = "dashedSeparator-s3R8K";
var _6 = "retentionPriceDetails-2jPWh";
export { _1 as "__esModule", _2 as "root", _3 as "totalRefund", _4 as "priceHeadTitle", _5 as "dashedSeparator", _6 as "retentionPriceDetails" }
export default { "__esModule": _1, "root": _2, "totalRefund": _3, "priceHeadTitle": _4, "dashedSeparator": _5, "retentionPriceDetails": _6 }
